import { ThemeConstants } from 'owa-theme-shared';
import { isFeatureEnabled } from 'owa-feature-flags';

const darkModeSupport = {
    [ThemeConstants.BASE_THEME_ID]: true,
};

export function themeSupportsDarkMode(themeName: string): boolean {
    return !!darkModeSupport[themeName] || isFeatureEnabled('fwk-darkThemeExtended');
}
